import React from 'react'
import Decimal from 'decimal.js'

const CartItem = ({ item, index }) => {
    const getItemTitle = () => {
        if (item.name?.includes('Top up Charges')) {
            return item.name.split('Top up Charges')[0]
        }

        if (Array.isArray(item.variants) && item.variants.length > 0) {
            const variant = item.variants[0]
            return variant.name === 'Default Title' ?
                    `${item.name} × ${variant.quantity}`
                :   `${variant.name} × ${variant.quantity}`
        }
        return item.name
    }

    const getSelections = () => {
        if (item.name?.includes('Top up Charges') || !Array.isArray(item.selections) || item.selections.length === 0) {
            return null
        }

        const selectionNames = item.selections
            .flatMap(sel => sel.options || [])
            .map(opt => (opt.quantity > 1 ? `${opt.name} × ${opt.quantity}` : opt.name))
            .join(' · ')

        return selectionNames ? `+ ${selectionNames}` : null
    }

    const getTotalPrice = () => {
        const { variants, selections } = item

        const selectionPrice = (selections || []).reduce((acc, sel) => {
            const optionsTotal = (sel.options || []).reduce((oacc, opt) => {
                const price = new Decimal(opt?.sellPrice || 0)
                const qty = new Decimal(opt?.quantity || 0)
                return oacc.plus(price.times(qty))
            }, new Decimal(0))
            return acc.plus(optionsTotal)
        }, new Decimal(0))

        const variantsPrice = (variants || []).reduce((acc, v) => {
            const sell = new Decimal(v?.sellPrice || 0)
            const qty = new Decimal(v?.quantity || 0)
            return acc.plus(sell.plus(selectionPrice).times(qty))
        }, new Decimal(0))

        return variantsPrice.toDecimalPlaces(2).toFixed(2)
    }

    return (
        <div className="col-12">
            <div className="card border-2 rounded-4 h-100">
                <div className="card-body py-3 px-3">
                    <div className="">
                        <div className="d-flex flex-row align-items-center justify-content-between gap-5">
                            {/* <div className="d-flex flex-row gap-5 align-items-center"> */}
                            <div>
                                <div className="card-title fw-bold m-0" style={{ fontSize: '1.5rem' }}>
                                    {getItemTitle()}
                                </div>
                                {getSelections() && (
                                    <div className="m-0" style={{ fontSize: '1.2rem', color: '#6c757d' }}>
                                        {getSelections()}
                                    </div>
                                )}
                            </div>
                            <div className="fw-bold text-end" style={{ fontSize: '1.5rem' }}>
                                ${getTotalPrice()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartItem
